// extracted by mini-css-extract-plugin
module.exports = {"button":"saveButtonStyles_button__1TaMe","selected":"saveButtonStyles_selected__2uMSp"};